/* eslint 'no-throw-literal': 0 */
import Validator from '../../validator/validator.js';

export default angular.module('BaseClass.validatable.validaters.exclusion',[Validator])
    .factory('exclusion', function(BCValidator) {
        function exclusion(value, instance, field) {
            if (value === undefined || value === '' || value === null) return true;
            if (!this.from) throw "Exclusion validator must specify 'from' attribute.";
            var included = true;
            this.from.forEach(function(i) {
                if (i === value)
                    included = false;
            });
            return included;
        }

        exclusion.message = function() {
            var list;
            var lastVal = 'or ' + this.from.slice(-1);
            var joinedArray = this.from.slice(0, -1);
            joinedArray.push(lastVal);
            if (joinedArray.length >= 3)
                list = joinedArray.join(', ');
            else
                list = joinedArray.join(' ');
            return 'must not be ' + list + '.';
        };


        return new BCValidator(exclusion,'exclusion');
    }).name;
